import React from 'react';
import PropTypes from 'prop-types';
import s from './BottomBar.css';
import { Stack } from './Stack';
import { CSSTransitionGroup } from 'react-transition-group';

const propTypes = {
    children: PropTypes.node.isRequired,
    show: PropTypes.bool.isRequired,
};

export class BottomBar extends React.Component {
    render() {
        return (
            <CSSTransitionGroup
                component="div"
                className={s.bar}
                transitionName="slide"
                transitionEnterTimeout={400}
                transitionLeaveTimeout={300}
            >
                {this.props.show && (
                    <div className={s.wrapper}>
                        <Stack className={s.content}>{this.props.children}</Stack>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }
}

BottomBar.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/containers/BottomBar.jsx